var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticStyle:{"width":"100%","text-align":"left"}},[_c('el-header',[_c('global-header',{attrs:{"app-type":_vm.appType}})],1),_c('el-main',{style:(_vm.display_style[_vm.appType])},[_c('certify-page',{attrs:{"account-name":_vm.accountName},on:{"onSubmit":_vm.handleSubmit}})],1),_c('el-footer',[_c('global-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }